<div class="row mx-0">
    <div class="col-md-3 col-lg-2">
        <app-navigation [isAdmin]="isAdmin"></app-navigation>
    </div>
    <div class="col-md-9 col-lg-10">
        <app-toolbar *ngIf="!isSiteBannerDisplayed || checkAdminPage()" [userName]="userName"></app-toolbar>
        <app-site-banner (bannerEvent)="setSiteBannerDisplayedFormat($event)"></app-site-banner>
        <router-outlet></router-outlet>
    </div>
</div>